<template>
  <el-dialog
    :title="$t('consumer-profile.reset-password.title')"
    :visible="true"
    width-size="small"
    height-size="fixed-auto"
    append-to-body
    @close="hideDialog"
  >
    <div class="px-24 py-16">
      {{ message }}
    </div>
    <template #footer>
      <el-button
        v-if="step === 1"
        type="secondary"
        @click="hideDialog"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        v-if="step === 1"
        @click="sendResetPasswordEmail"
      >
        {{ $t('action.send') }}
      </el-button>
      <el-button
        v-if="step === 2"
        type="secondary"
        @click="sendResetPasswordEmail"
      >
        {{ $t('action.send') }}
      </el-button>
      <el-button
        v-if="step === 2"
        @click="hideDialog"
      >
        {{ $t('action.got-it') }}
      </el-button>
    </template>
  </el-dialog>
</template>

  <script>
  import { mapActions } from 'vuex';

  export default {
    name: 'ResetPasswordDialog',
    props: {
      user: {
        type: Object,
        default: () => ({
          login: '',
          email: ''
        })
      }
    },
    emits: [
      'hide'
    ],
    data() {
      return {
          step: 1
      };
    },
    computed: {
      message() {
        return this.step === 1 ? this.$t('consumer-profile.reset-password.message-instructions') : this.$t('consumer-profile.reset-password.message-sent');
      }
    },
    methods: {
    ...mapActions('app', ['resetPassword']),
      async sendResetPasswordEmail() {
        if (this.step === 1) {
          this.step++;
        }
        await this.resetPassword(
          {
            login: this.user.login,
            email: this.user.email
          }
        );
      },
      hideDialog() {
        this.$emit('hide');
      }
    }
  };
  </script>
